import React from 'react';
import './Square.css';

const Square = ({ letter = '', status = '', type = 'tile', onClick}) => {
    const className = `square ${type} ${status}`;
    return (
        <div className={className} onClick={onClick}>
            {letter}
        </div>
    );
};

export default Square;
